import React from "react";
import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ show, size = 16, className = "" }) {
  if (!show) return null;
  return (
    <span
      data-testid="verified-badge"
      title="Artist Pass member"
      className={`inline-flex items-center justify-center ${className}`}
      style={{ filter: "drop-shadow(0 0 6px rgba(16,185,129,0.6))" }}
    >
      <BadgeCheck className="text-emerald-400 fill-emerald-400/15" style={{ width: size, height: size }} />
    </span>
  );
}
